<template>
  <div>
    <b-modal
      id="add-transaction"
      ref="modal"
      header-class="headerModal"
      no-close-on-backdrop
      centered
      size="lg"
      :title="$t('AddTransaction')"
      hide-footer
    >
      <b-form>
        <div style="display: flex; flex-direction: column; width: 100%; justify-content: space-between;">
          <div style="display: flex; justify-content: space-between;gap: 10px;">
            <b-form-group
              :label="$t('AccountId')"
              style="width: 100%;padding-bottom: 10px;"
            >
              <b-form-input
                v-model="items.accountId"
                :placeholder="$t('AccountId')"
                aria-describedby="input-1-live-feedback"
              />
              <b-form-invalid-feedback
                id="input-1-live-feedback"
              >{{ $t('This_is_a_required_field_and_must_be_at_least_3_letters') }}</b-form-invalid-feedback>
            </b-form-group>

            <b-form-group
              :label="$t('Amount')"
              style="width: 100%;padding-bottom: 10px;"
            >
              <b-form-input

                v-model="items.amount"
                :placeholder="$t('Amount')"
                aria-describedby="input-2-live-feedback"
              />
            </b-form-group>
          </div>
          <div style="display: flex; justify-content: space-between;gap: 10px;">
            <b-form-group
              :label="$t('TransactionType')"
              style="width: 100%;padding-bottom: 10px;"
            >
              <b-form-input

                v-model="items.transactionType"
                :placeholder="$t('TransactionType')"
                aria-describedby="input-2-live-feedback"
              />
            </b-form-group>
            <b-form-group
              :label="$t('Notes')"
              style="width: 100%;padding-bottom: 10px;"
            >
              <b-form-input

                v-model="items.notes"
                :placeholder="$t('Notes')"
                aria-describedby="input-2-live-feedback"
              />
            </b-form-group>
          </div>
        </div>
      </b-form>

      <div class="buttonsEverywhere">
        <button
          type="button"
          variant="none"
          style="margin-left: 0px;"
          class="buttonSubmit"
          @click="onSubmit"
        >
          {{ $t('VacationSubmit') }}
        </button>
        <b-button
          type="reset"
          variant="danger"
          class="buttonCancel"
          style="margin-right: 15px; background: white; color: black; border-color: white;font-weight: 400;"
          @click="onCancel"
        >
          {{ $t('Cancel') }}
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
// import DatePicker from 'vue2-datepicker';
// import moment from 'moment-timezone';

export default {
  components: {
    // DatePicker,
  },
  props: [],
  data() {
    return {
      items: {
        accountId: null,
        amount: null,
        transactionType: null,
        notes: null,
      },
    }
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      // this.$v.form.$touch();
      // if (this.$v.form.$anyError) {
      //   return;
      // }
      this.$emit('addTransaction', this.items)
      this.$refs.modal.hide()
      this.resetForm()
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
    },
    onCancel() {
      this.$refs.modal.hide()
      setTimeout(() => { this.$v.$reset() }, 0)
      this.$nextTick(() => { this.$v.$reset() })
      this.resetForm()
    },
    resetForm() {
      this.items.accountId = null
      this.items.amount = null
      this.items.transactionType = null
      this.items.notes = null
    },
  },
}
</script>

<style lang="scss" scoped>
  form {
    grid-template-columns: 1fr 1fr;
    gap: 10px;
  }
  .deactivate-modal__select {
    display: flex;
    flex-direction: column;
    select {
      margin-bottom: 10px;
      padding: 10px;
    }
    button {
      align-self: end;
    }
  }
  .flex-form {
    display: flex;
    flex-direction: column;
  }
  .my-class {
  background: black;
  font-weight: bold;
}

  // .my-second-class > .modal-dialog > .modal-content > .modal-header {
  // background: black;
  // color: white;
  // }
</style>
